<design-slide-up-card
  [isCardOpen]="!!isCardOpen"
  [showBackgroundImage]="true"
  [hideHeaderInDesktop]="true"
  [showLogoInHeader]="true"
  class="route-planning-results"
  [class]="direction"
  [roleDialog]="true"
  [dialogAriaLabel]="stationDetailsText"
  [title]="titleText"
  >
  @if (isNavigatingToStation) {
    <app-loader/>
  }
  <!--
    a11y: on mobile (where the slide-up acts as a fullscreen dialog) the audit
    requires initial focus to land on the back/close chevron rather than on
    nothing / underlying content. focusInitialOnBack forwards cdkFocusInitial
    to the inner native <button>; the outer OverlayComponent focus trap then
    pulls focus to it via focusInitialElementWhenReady. On desktop the trap
    falls back to the first tabbable element in the dialog (which is also this
    back chevron), so we deliberately only set it on mobile to avoid stealing
    focus from the desktop layout's preferred initial focus.
  -->
  <app-results-header
    [focusInitialOnBack]="!!isMobile"
    (onBackClick)="handleCloseClick()"
    [class]="direction"
    >
    <ng-container buttons>
      <mot-button
        type="button"
        icon="share-nodes"
        buttonClass="!text-white !bg-transparent"
        iconClass="!text-2xl"
        [text]="shareText"
        (onClick)="openShareLinkPopup()" ariaHaspopup="dialog" />

          <mot-menu
            [menuVert]="false"
            [menuItems]="moreActionsMenuItems"
            [menuButtonAriaLabel]="moreActionsMenuText"
            dir="rtl"
            buttonClass="!rounded-xl !text-white !bg-transparent !w-8 !h-8 !min-w-0"
            buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]" />
          </ng-container>

          <div content class="flex flex-col gap-2 text-white" >
            <app-station-details [station]="data.stop" [stopcodeColor]="'#ffffff'" />
          </div>
        </app-results-header>

        <div class="bg-white rounded-t-xl flex-1 overflow-hidden min-h-0" id="printableArea">
          <mat-tab-group
            [dir]="direction"
            mat-stretch-tabs="false"
            dynamicHeight="false"
            [disableRipple]="true"
            class="bg-white h-full rounded-t-xl use-padding">
            <mat-tab>
              <ng-template mat-tab-label>{{ stationDetailsText }}</ng-template>
              <app-search-station-deatiled-result-details
                [stop]="data.stop"
                (closeCardEvent)="handleCloseClick(true)"
                (navigateToStationEvent)="this.isNavigatingToStation = $event"
                />
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>{{ linesCalendarText }}</ng-template>
                <app-search-station-deatiled-result-routes-calendar
                  class="max-w-full w-full"
                  [stop]="data.stop"
                  (closeCardEvent)="handleCloseClick(true)"
                  />
                </mat-tab>

                @if (!!isMobile) {
                  <mat-tab>
                    <ng-template mat-tab-label>{{ showOnMapText }}</ng-template>
                    <ng-template matTabContent>
                      <app-search-station-deatiled-result-map [stop]="data.stop"/>
                    </ng-template>
                  </mat-tab>
                }
              </mat-tab-group>
            </div>
          </design-slide-up-card>
